<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta content="width=device-width, initial-scale=1.0" name="viewport">

    <title>Remote Monitoring System</title>
    <meta content="" name="description">
    <meta content="" name="keywords">

    <!-- Favicons -->
    <!-- <link href="assets/img/favicon.png" rel="icon">-->
    <link href="assets/img/apple-touch-icon.png" rel="apple-touch-icon">

    <!-- Google Fonts -->



</head>

<body>



    <app-header></app-header>

    <!-- ======= Hero Section ======= -->
    <section id="hero" class="blue_bg_clr">
        <owl-carousel [options]="SlideOptions" [carouselClasses]="['owl-theme', 'sliding']">
            <div class="item" *ngFor="let img of Images">
                <div style="align-content: center">
                    <div class="carousel-container">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 slider-left-text-auto pb-2">
                                    <h2 class="animate__animated animate__fadeInDown text-alignment-center">
                                        {{img.title}}</h2>
                                    <p class="animate__animated animate__fadeInUp text-alignment text_jus1">{{img.text}}
                                    </p>
                                    <div class="button_flex">
                                        <a href="{{img.button}}"
                                            class="btn-get-started animate__animated animate__fadeInUp scrollto text-alignment">Get
                                            Started</a>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <img src="{{img.img}}" class="slider-img">

                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </owl-carousel>
    </section>

    


    <!-- End Hero -->

    <main id="main">
        <section id="clients" class="clients">
            <div class="container p-0">


                <div class="row client-logo-main">

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/rech.svg" class="img-fluid" alt="">
                    </div>

                </div>

            </div>
        </section>

        <!-- ======= RMS IoT Section ======= -->

        <section id="cta" class="cta">
            <div class="container aos-init aos-animate" data-aos="zoom-in">
                <div class="row display_two_column">
                    <div class="first_column_image pb-3">
                        <img src="assets/img/iot-chart.svg">
                    </div>
                    <div class="second_column_text">
                        <div class="second_column_image">
                            <h3 style="text-align: left;">RMS IoT (An End-To-End IoT Business Solution)</h3>
                            <p class="mt-30 margin-bottom-0 text_jus"> Samyak Offers End to End IIOT solution for
                                industry 4. O.
                                RMS comes with hardware-software & their connectivity.
                            </p>
                            <p class="margin-0 text_jus">4g Data Logger gathers Real-Time data from machines & sends it
                                to the
                                cloud</p>
                            <p class="text_jus">
                                On software side Samyak provides both web and mobile application which will fetch data
                                from cloud sent by modem.Web and mobile applications are completely user configurable.
                                Using it user can configure GSM modem remotely. Dashboard and Reports generated from
                                data are also user configurable.
                                Using data analytics it also does anomaly detection and sends alerts to users.</p>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ======= Services Section ======= -->
        <section id="services" class="services">
            <div class="container aos-init aos-animate" data-aos="fade-up">

                <div class="section-title">

                    <p class="pt-4 pb-1">RMS Provides Following Best Services</p>

                </div>

                <div class="align-items-center text-center justify-content-center">
                    <img src="assets/images/RMS-Gif.gif" class="img-fluid cust-img-fluid-new" alt="">
                </div>

            </div>
        </section>



        <!-- ======= Advanced Energy ======= -->

        <section id="Advanced Energy" class="services mt-30 section-bg padding-bottom-50">
            <div class="container aos-init aos-animate" data-aos="fade-up">

                <div class="section-title">

                    <p class="pt-3 pb-2">Brief Overview of RMS</p>

                </div>

                <div class="align-items-center text-center justify-content-center pt-2">

                    <video class="iframe" controls width="80%">
                        <source src="assets/img/Level Monitoring1.mp4" type="video/mp4">
                    </video>

                </div>

            </div>
        </section>
        <!-- ======= How Rms Works ======= -->






        <section id="How-Rms-Works" class="services">
            <div class="container aos-init aos-animate">

                <div class="section-title">

                    <p class="pt-3">How RMS Works ?</p>

                </div>

                <div class="row">
                    <div class="col-lg-9 col-md-8 col-12">

                        <div class="col-lg-12 col-md-12 col-12 text-center howrmswork">
                            <img class="img-size" src="assets/img/image 14.svg" alt="image">
                        </div>

                    </div>
                    <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                        <div class="col-lg-12 col-md-12 col-sm-12 align-items-stretch mt-4 aos-init "
                            style="padding-right: 15px !important;padding-left: 15px !important;">
                            <div class="icon-box height-245 border services icon-box-new">
                                <div class="icon-container mb-icon-container"><img class="cust-img-size"
                                        src="assets/img/search.svg"></div>
                                <div style="display: flex; justify-content: center;">
                                    <h4 class="h4"><a href="">Installation</a></h4>
                                </div>
                                <p class="p-font-14">Simple, easy to use and installation
                                    time of less than 5 minutes</p>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 align-items-stretch mt-4 aos-init"
                            style="padding-right: 15px !important;padding-left: 15px !important;">
                            <div class="icon-box height-245 border services icon-box-new">
                                <div class="icon-container mb-icon-container"><img class="cust-img-size"
                                        src="assets/img/configuration.svg"></div>
                                <div style="display: flex; justify-content: center;">
                                    <h4 class="h4"><a href="">Configuration</a></h4>
                                </div>
                                <p class="p-font-14">User defined setting for all equipment registers, their limits &
                                    priority based alert.</p>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 align-items-stretch mt-4 aos-init"
                            style="padding-right: 15px !important;padding-left: 15px !important;">
                            <div class="icon-box height-245 border services icon-box-new">
                                <div class="icon-container mb-icon-container"><img class="cust-img-size"
                                        src="assets/img/monitoring11.svg"></div>
                                <div style="display: flex; justify-content: center;">
                                    <h4 class="h4"><a href="">Monitoring</a></h4>
                                </div>
                                <p class="p-font-14">24×7 Real-Time insights via dashboards and reports.</p>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </section>


        <!-- ======= Testimonials Section ======= -->
        <section id="testimonials" class="testimonials section-bg services padding-bottom-0 mt-30">
            <div class="pad_15">
                <div class="container aos-init aos-animate" data-aos="fade-up">

                    <div class="section-title">

                        <p class="pt-3">We Provide Best Services</p>

                    </div>

                    <div class="best_service">
                        <owl-carousel [options]="SlideOptions1" [carouselClasses]="['owl-theme', 'sliding']">
                            <div class="item" *ngFor="let img of Images1">
                                <div style="align-content: center">
                                    <div class="icon-box icon-box2">
                                        <div class="icon-container"><img src="{{img.img}}"></div>
                                        <h4><a href="">{{img.title}}</a></h4>
                                        <p class="icon-box-p text_jus" style="margin-bottom: 0px !important;">
                                            {{img.text}}<span><a href="{{img.button}}"
                                                    class="anc">Read&nbsp;More</a></span></p>
                                    </div>
                                </div>
                            </div>
                        </owl-carousel>
                    </div>
                </div>
            </div>
        </section>

        <!-- ======= Testimonials2 Industries We Serve Section ======= -->
        <section id="testimonials" class="industries testimonials section-bg services">
            <div class="container aos-init aos-animate" data-aos="fade-up">

                <div class="section-title">

                    <p class="pt-3" style="color: #fff;">Industries We Serve</p>

                </div>

                <div class="best_service">
                    <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
                        <div class="item" *ngFor="let img of Images2">
                            <div class="">
                                <div class="icon-container34">
                                    <p><img class="indus-img" src="{{img.img}}"></p>
                                    <div class="h3">{{img.title}}</div>
                                </div>
                            </div>
                        </div>
                    </owl-carousel>
                </div>

            </div>
        </section>

        <section id="testimonial-area" class="pt-5 padding-bottom-new">

            <div class="container">
                <div class="mx-auto">
                    <header class="section-header text-center">
      
                        <h2  class="m_top">What our Customers are Saying</h2>
                    </header>
                </div>
                <div class="testimonial-block" style="padding-bottom: 40px; padding-top: 45px;">
                    <div style="width: 428px;" class="image_display"><img src="assets/img/user5.svg" alt=""
                            class="testimonial_img"></div>
      
                    <div class="padding-both-side">
      
                        <h1> <span><img src="../../assets/img/comma.svg" class="commam"></span></h1>
                        <p class="text_align_center" style="font-size: 14px;">“Samyak's support is really good and we are
                            very happy with the services they have provided to us like hardware data integration through GSM
                            gateways. Two way communication is helping us a big time. We heartily appreciate all kind of
                            support.”</p>
                        <div class="testimonial">
                            <p class="testimonialFrom text_align_center" style="font-size: 14px;">Jummal Popis</p>
                            <p class="text_align_center" style="font-size: 14px;">Founder Circle</p>
                        </div>
                    </div>
                </div>
      
      
      
            </div>
      
        </section>
      


        <!-- ======= Check out latest article ======= -->
        <app-latest-article></app-latest-article>




    </main><!-- End #main -->
    <!-- ======= Footer ======= -->
    <app-footer></app-footer>
    <!-- End Footer -->
    <!-- <div id="preloader"></div> -->
    <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
            class="bi bi-arrow-up-short"></i></a>



    <!-- Testimonial js -->
    <script>
        System.import('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js')
        $(document).ready(function () {

            $('.client-single').on('click', function (event) {
                event.preventDefault();

                var active = $(this).hasClass('active');

                var parent = $(this).parents('.testi-wrap');

                if (!active) {
                    var activeBlock = parent.find('.client-single.active');

                    var currentPos = $(this).attr('data-position');

                    var newPos = activeBlock.attr('data-position');

                    activeBlock.removeClass('active').removeClass(newPos).addClass('inactive').addClass(currentPos);
                    activeBlock.attr('data-position', currentPos);

                    $(this).addClass('active').removeClass('inactive').removeClass(currentPos).addClass(newPos);
                    $(this).attr('data-position', newPos);

                }
            });

        }(jQuery));

    </script>
    <script>

        var testimonialItems = document.querySelectorAll(".item label");
        var timer;
        function cycleTestimonials(index) {
            timer = setTimeout(function () {
                var evt;
                if (document.createEvent) {
                    //If browser = IE, then polyfill
                    evt = document.createEvent('MouseEvent');
                    evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                } else {
                    //If Browser = modern, then create new MouseEvent
                    evt = new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: true,
                        clientX: 20
                    });
                }
                var ele = "." + testimonialItems[index].className;
                var ele2 = document.querySelector(ele)
                ele2.dispatchEvent(evt);
                index++; // Increment the index
                if (index >= testimonialItems.length) {
                    index = 0; // Set it back to `0` when it reaches `3`
                }
                cycleTestimonials(index); // recursively call `cycleTestimonials()`
                document.querySelector(".testimonials").addEventListener("click", function () {
                    clearTimeout(timer); //stop the carousel when someone clicks on the div
                });
            }, 3000); //adjust scroll speed in miliseconds
        }
        //run the function
        cycleTestimonials(0);
    </script>


</body>

</html>